import CheckmarkFilled16 from '@carbon/icons-react/es/checkmark--filled/16';
import styled from 'styled-components';

const Wrapper = styled.div`
  color: var(--green-50);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CheckmarkIcon = (): React.JSX.Element => {
  return (
    <Wrapper>
      <CheckmarkFilled16 />
    </Wrapper>
  );
};
